
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150.25 150.25"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"75.12","cy":"75.12","r":"75.12","fill":"#3b7cf7"}}),_c('path',{attrs:{"d":"M82.31,53.77C85.49,57,88.6,71.56,88.6,71.56S74,68.44,70.82,65.27a8.13,8.13,0,1,1,11.49-11.5Z","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('path',{attrs:{"d":"M94.89,53.77C91.72,57,88.6,71.56,88.6,71.56s14.61-3.12,17.79-6.29a8.13,8.13,0,1,0-11.5-11.5Z","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('line',{attrs:{"x1":"88.6","y1":"42.46","x2":"88.6","y2":"105.79","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('line',{attrs:{"x1":"115.29","y1":"71.56","x2":"35.47","y2":"71.56","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('rect',{attrs:{"x":"34.1","y":"42.46","width":"81.19","height":"63.33","rx":"6","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])
          )
        }
      }
    